import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';
import { Sidebar } from '@futrli/ui-components';

import * as styles from './mobile-menu-drawer.scss';

interface Props {
  readonly menuItems: React.ReactNode[];
}

export const MobileMenuDrawer = ({ menuItems }: Props): JSX.Element => {
  const intl = useIntl();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <React.Fragment>
      <section style={{ display: 'flex', alignItems: 'center' }}>
        <div className={styles.iconButtonContainer}>
          <Button
            onClick={() => setIsOpen(true)}
            aria-label={intl.formatMessage({
              id: 'common.mobile_menu_trigger.aria_label',
              defaultMessage: 'Mobile menu trigger'
            })}
            buttonType="tertiary"
            p={0}
          >
            <Icon type="entry" inputSize="small" color="#fff" />
          </Button>
        </div>
        <div className={styles.sidebarContainer}>
          <Sidebar
            aria-label={intl.formatMessage({
              id: 'common.mobile_sidebar.aria_label',
              defaultMessage: 'Mobile sidebar'
            })}
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            className={styles.sidebarContainer}
            padding={0}
          >
            <Box height="48px" backgroundColor="--colorsGray850" />
            <div className={styles.drawerCarbon} role="presentation" onClick={() => setIsOpen(false)}>
              {menuItems}
              <Box>
                <Typography fontSize="14px" fontWeight="500" color="#fff">
                  <FormattedMessage
                    id="skeleton.login_description_on_desktop"
                    defaultMessage="Login to Futrli from your desktop to access Flow In, Flow Out and the whole Futrli Platform"
                  />
                </Typography>
                <Typography fontSize="14px" fontWeight="500" textTransform="uppercase" color="#fff">
                  <FormattedMessage id="skeleton.coming_soon_mobile" defaultMessage="*coming soon on mobile" />
                </Typography>
              </Box>
            </div>
          </Sidebar>
        </div>
      </section>
    </React.Fragment>
  );
};
